module.exports = __webpack_public_path__ + "img/extended.3aee364f.png";